import { useContextTranslation } from '@core/i18n';
/**
 * @returns a function which accepts `subtitles` param and returns the translated subtitle label
 */
export const useSubtitlesLabel = () => {
    const { t } = useContextTranslation();
    return (subtitles) => {
        let language = undefined;
        try {
            // We don't want language translated to the user's language, it
            // needs to be in its own language. Wrapping with try/catch because
            // the Intl.DisplayNames is not always supported.
            language = new Intl.DisplayNames([subtitles.srclang], {
                type: 'language',
            }).of(subtitles.srclang);
        }
        catch (e) { }
        return subtitles.is_cc
            ? t('player:{{lang}} (Captions)', {
                lang: language || subtitles.srclang.toUpperCase(),
            })
            : t('player:{{lang}} (Subtitles)', {
                lang: language || subtitles.srclang.toUpperCase(),
            });
    };
};
